import type { DashboardDefensorResumoDto } from '@/api.types';
import api, { ValidateAxiosError } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';

export async function BuscarResumoHomeDefensor(): Promise<DashboardDefensorResumoDto | null> {
  try {
    const response = await api.get<DashboardDefensorResumoDto>(`${Endpoints.DASHBOARD}/defensor/resumo`);
    return response.data ?? null;
  } catch (error) {
    ValidateAxiosError(error, 'Não foi possível carregar o resumo do defensor.');
    return null;
  }
}
